import dayjs from "dayjs";

import { combineConfigs, dayAndShortMonth, shortMonthAndShortYear } from "@similarweb/pro-logic-components";

import { numFilter } from "app/pages/digital-marketing/backlinks/shared/BacklinksUtils";
import { GranularityNames } from "app/UtilitiesAndConstants/Constants/Moment";

function getTickIntervalFromDays(daysValue: number) {
    return daysValue * 24 * 3600 * 1000;
}

function getGranularityInDays(timeGranularity: GranularityNames) {
    switch (timeGranularity) {
        case GranularityNames.DAILY:
            return 1;
        case GranularityNames.WEEKLY:
            return 7;
        case GranularityNames.MONTHLY:
            return 30;
    }
}

const granularityDateformat = {
    [GranularityNames.MONTHLY]: shortMonthAndShortYear,
    [GranularityNames.WEEKLY]: dayAndShortMonth,
    [GranularityNames.DAILY]: dayAndShortMonth,
};

export const getBacklinksChartConfig = (timeGranularity: GranularityNames, overwriteParams: object = {}) => {
    const markerEnabledGranularities = [GranularityNames.MONTHLY, GranularityNames.WEEKLY];
    const isMarkerEnabled = markerEnabledGranularities.includes(timeGranularity);
    const formatter = granularityDateformat[timeGranularity] ?? granularityDateformat[GranularityNames.MONTHLY];
    const yAxisFormatter = ({ value }: { value: number | string }) => numFilter(value) as string;
    const xAxisFormatter = ({ value }: { value: number | string }) => {
        return dayjs.utc(value).format(formatter);
    };
    const tickInterval = getTickIntervalFromDays(getGranularityInDays(timeGranularity));

    return combineConfigs({}, [
        {
            plotOptions: {
                series: {
                    marker: {
                        enabled: isMarkerEnabled,
                        symbol: "circle",
                        enabledThreshold: isMarkerEnabled ? 0 : Infinity,
                    },
                },
            },
            yAxis: {
                labels: {
                    formatter: function () {
                        return yAxisFormatter(this);
                    },
                },
            },
            xAxis: {
                gridLineWidth: 0,
                gridLineDashStyle: "Dash",
                tickLength: 5,
                tickInterval,
                ordinal: true,
                labels: {
                    formatter: function () {
                        return xAxisFormatter(this);
                    },
                },
            },
        },
        overwriteParams,
    ]);
};
